import { useMemo } from 'react';
import { GridColDef } from '@mui/x-data-grid-pro';
import { Grid, Typography } from '@mui/material';
import { PhoenixGrid } from '@shared/components/grid/PhoenixGrid';
import { gridDateTimeFormatter } from '@shared/commonFunctions';
import { dataGridCol } from '@shared/components/grid/common';
import { TextInput } from '@shared/inputs/TextInput';
import { Modal } from '@shared/components/modals/Modal';
import { DealsButton } from '@styles/StyledButtons';
import { ModalFooter } from '@styles/ModalStyles';
import { ICustomPdfModalProps } from '../interfaces';

const textColor = '#0B5179';

export const CustomPdfModal = ({ 
  selectedFiles, 
  fileName, 
  pdfModalPosition, 
  handleFileNameChange, 
  handleClose, 
  generateCustomPdf,
}: ICustomPdfModalProps) => {
  const columns: GridColDef[] = [
    dataGridCol('uploadedOn', {
      minWidth: 150,
      valueFormatter: gridDateTimeFormatter,
      disableColumnMenu: true
    }),
    dataGridCol('stipType', {
      minWidth: 200,
      headerName: 'Type',
      disableColumnMenu: true
    }),
    dataGridCol('fileName', {
      minWidth: 300,
      flex: 2,
      disableColumnMenu: true
    }),
    dataGridCol('uploadedTo', {
      minWidth: 80,
      disableColumnMenu: true
    })
  ].map((column) => ({flex: 1, ...column}));

  const sortSelectedFiles = useMemo(() =>
      [...(selectedFiles || [])].sort((firstFile, secondFile) => (firstFile.isDeleted === secondFile.isDeleted ? 0 : firstFile.isDeleted ? 1 : -1))
      , [selectedFiles]);

  return (
    <Modal
      hideBackdrop
      open={!!pdfModalPosition}
      resetPosition={pdfModalPosition}
      title="Files Custom PDF Generator"
      dialogWidth="1000px"
      onClose={handleClose}
    >
      <>
        <PhoenixGrid
          withHeader
          canNotCopy
          canNotEdit
          noButton
          autoHeight
          isRowSelectable={() => false}
          columns={columns}
          getRowId={(row) => row.contactStipId}
          rows={sortSelectedFiles}
        />
        
        <ModalFooter>
          <Grid
            container
            alignItems="left"
          >
            <Grid item xs={2}>
              <Typography variant="h3" color={textColor}>File Name</Typography>
            </Grid>

            <Grid item xs={6}>
              <TextInput
                value={fileName}
                onChange={({ target: { value } }) => handleFileNameChange(value)}
              />
            </Grid>

            <Grid item xs={1}>
              <Typography variant="h3" pl={3} color={textColor}>.pdf</Typography>
            </Grid>

            <Grid item xs={3}>
              <DealsButton
                type="button"
                disabled={!fileName}
                onClick={generateCustomPdf}
              >
                Generate PDF  
              </DealsButton>
            </Grid>
          </Grid>
        </ModalFooter>
      </>
    </Modal>
  );
};
